import { createSelector } from 'reselect'
import locationSelector from './locationSelector'

const currentPathnameSelector = createSelector(
    locationSelector,
    (location): string => location.pathname,
)

export default currentPathnameSelector
